module.exports = __webpack_public_path__ + "static/media/Chespin_gaussian2.979e8033.png";